import script from "./CompositeStem.vue?vue&type=script&setup=true&lang=js"
export * from "./CompositeStem.vue?vue&type=script&setup=true&lang=js"

import "./CompositeStem.vue?vue&type=style&index=0&id=40a8bb55&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a8bb55"]])

export default __exports__